<template>
    <div>
        <!-- edit spec modal start -->
        <form @submit.prevent="confirmUpdateVesselSpecs">
            <div class="modal fade" tabindex="-1" id="edit-spec-modal">
                <div class="modal-dialog">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit Specification</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cancelEdit">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form action="">
                            <div class="form-group">
                                <label for="gross-tonnage">Gross Tonnage (International)</label>
                                <input v-model="tempVesselSpecification.grosston" type="text" class="form-control" id="gross-tonnage">
                                 <small 
                                        v-show="vesselSpecificationErrors.grosston"
                                        class="form-text text-danger"
                                >
                                    {{ vesselSpecificationErrors.grosston }}
                                </small>
                            </div>

                            <div class="form-group">
                                <label for="engine_type">Type of Engine</label>
                                <input v-model="tempVesselSpecification.engine_type" type="text" class="form-control" id="engine_type">
                                 <small 
                                        v-show="vesselSpecificationErrors.engine_type"
                                        class="form-text text-danger"
                                >
                                    {{ vesselSpecificationErrors.engine_type }}
                                </small>
                            </div>
                            <div class="form-group">
                              <label for="max_capacity">Max. Capacity</label>
                              <input v-model="tempVesselSpecification.max_capacity" type="number" class="form-control"
                                     min="1"
                                     id="max_capacity">
                              <small
                                  v-show="vesselSpecificationErrors.max_capacity"
                                  class="form-text text-danger"
                              >
                                {{ vesselSpecificationErrors.max_capacity }}
                              </small>
                            </div>
                            <div class="form-group">
                              <label for="no_of_cabins">No. of Cabins</label>
                              <input v-model="tempVesselSpecification.no_of_cabins" type="number" class="form-control"
                                     min="1"
                                     id="no_of_cabins">
                              <small
                                  v-show="vesselSpecificationErrors.no_of_cabins"
                                  class="form-text text-danger"
                              >
                                {{ vesselSpecificationErrors.no_of_cabins }}
                              </small>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                            @click="cancelEdit"
                        >
                            Cancel
                        </button>
                        <button class="btn btn-primary">Save changes</button>
                    </div>
                    </div>
                </div>
            </div>
        </form>
        <!-- edit spec modal end -->

        <div>
            <p class="font-weight-bold">
                Specification
                <template v-if="isSystemAdmin">
                    <button
                        type="submit"
                        class="btn btn-sm btn-xs btn-warning font-weight-bold float-right mb-1"
                        data-toggle="modal"
                        data-target="#edit-spec-modal"
                    >
                        <span class="fas fa-user-edit"></span> Edit
                    </button>
                </template>
            </p>
            <div class="row text-small">
                <div class="col-sm-5">
                    <table class="table table-sm" id="specificationTable" v-if="vesselSpecification.id">
                        <tbody>
                        <tr>
                            <th scope="row" class="align-middle">
                                <label class="font-weight-bolder text-left form-label-xs"
                                >
                                    Gross Tonnage (International):
                                </label>
                            </th>
                            <td class="align-middle">
                                {{ vesselSpecification.grosston }}
                            </td>
                        </tr>

                        <tr>
                            <th scope="row" class="align-middle">
                                <label class="font-weight-bolder text-left form-label-xs">
                                    Type of Engine:
                                </label>
                            </th>
                            <td class="align-middle">
                                {{ vesselSpecification.engine_type }}
                            </td>
                        </tr>
                        <tr>
                          <th scope="row" class="align-middle">
                            <label class="font-weight-bolder text-left form-label-xs">
                              Max. Capacity:
                            </label>
                          </th>
                          <td class="align-middle">
                            {{ vesselSpecification.max_capacity }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" class="align-middle">
                            <label class="font-weight-bolder text-left form-label-xs">
                              No. of Cabins:
                            </label>
                          </th>
                          <td class="align-middle">
                            {{ vesselSpecification.no_of_cabins }}
                          </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { vueAppMixin} from "@/mixins/vueAppMixin";
import { gateMixin} from "@/mixins/gateMixin";
import { mapActions, mapGetters } from "vuex";
import {vesselMixin} from "@/mixins/vesselMixin";
import $ from 'jquery'
// import JQuery from 'jquery'
// window.$ = JQuery

export default {
    name: "VesselSpecification",
    mixins: [ vueAppMixin, gateMixin, vesselMixin ],

    data() {
        return {
            vesselSpecification: {},
            tempVesselSpecification: {},
            vesselSpecificationErrors: {},
            editable: false
        }
    },

    methods: {
        ...mapActions([ 'getVesselInfo_old', 'getVesselSpecs', 'updateVesselSpecs' ]),

        async confirmUpdateVesselSpecs() {
            if(await this.confirmUpdate()) {
                let updatedVesselSpecs = await this.updateVesselSpecs({
                    id : this.tempVesselSpecification.id,
                    grosston : this.tempVesselSpecification.grosston,
                    engine_type : this.tempVesselSpecification.engine_type,
                    no_of_cabins : this.tempVesselSpecification.no_of_cabins,
                    max_capacity : this.tempVesselSpecification.max_capacity
                });

                if(updatedVesselSpecs) {
                    if(updatedVesselSpecs.errors) {
                        this.vesselSpecificationErrors = updatedVesselSpecs.errors
                    } else {
                        this.initializeData();
                        this.vesselSpecificationErrors = {};
                        this.successAlert('Vessel Specifications Successfully Updated', 'UPDATE');
                        $('#edit-spec-modal').modal('hide');
                    }
                }
            }
        },

        async initializeData() {
            // await this.getVesselInfo_old({ id: this.vesselId });

            await this.getVesselSpecs({
                vesselId: this.vesselId
            });
            this.vesselSpecification = Object.assign({}, this.vesselSpecs);
            this.tempVesselSpecification = Object.assign({}, this.vesselSpecs)
        },

        cancelEdit() {
            this.tempVesselSpecification = this.vesselSpecification;
        }
    },

    computed: {
        ...mapGetters([ 'vessel', 'vesselSpecs' ]),

    },

    created() {
        // console.log($('#edit-spec-modal'))
        this.initializeData();
    }
}
</script>

<style scoped>

</style>
